// UUID v4 без зависимости от secure context.
//
// Нативный генератор из crypto доступен только в secure context (HTTPS или
// localhost). На дев-сервере, открытом по http:// на IP в локальной сети
// (проверка с телефона), его нет — и генерация id падает.
// crypto.getRandomValues() таким гейтом НЕ закрыт и работает в любом контексте,
// поэтому даём на него фолбэк.
//
// Прямой вызов нативного генератора запрещён линтом (no-restricted-properties) —
// этот файл единственная точка, где он разрешён.
export function randomUUID (): string {
  const c = globalThis.crypto

  // eslint-disable-next-line no-restricted-properties
  if (c && typeof c.randomUUID === 'function') return c.randomUUID()

  const bytes = new Uint8Array(16)
  c.getRandomValues(bytes)
  bytes[6] = (bytes[6] & 0x0f) | 0x40 // версия 4
  bytes[8] = (bytes[8] & 0x3f) | 0x80 // вариант 10xx
  const hex = Array.from(bytes, b => b.toString(16).padStart(2, '0'))

  return [
    hex.slice(0, 4).join(''),
    hex.slice(4, 6).join(''),
    hex.slice(6, 8).join(''),
    hex.slice(8, 10).join(''),
    hex.slice(10, 16).join('')
  ].join('-')
}
